export default async (context) => {
    if(context.text.length > 0) {
        await context.$store.dispatch('main_videos/setVideos', {
            video: context.preview[0]
        })

        context.$router.push('/video-editor')
    }
}